const ADHERENCE = {
  ALLOWED: 'S',
  DENIED: 'N',
}
const FACTOR_TYPE = {
  FIXE: 'F',
  MULTIPLIER: 'M',
}
const MODEL_TYPE = {
  CASHBACK: 'C',
  POINTS: 'P',
}
const AWARD_TYPE = {
  UNITY: 1,
  MONTH: 2,
  YEAR: 3,
  UNLIMITED: 4,
}
const PAY_WITH_CASHBACK = {
  ALLOWED: 'S',
  DENIED: 'N',
}
const TRANSACTION_TYPE = {
  CREDIT: 'C',
  DEBIT: 'D',
}
const TRANSACTION_STATUS = {
  PENDING: '1',
  CONFIRMED: '2',
  CANCELED: '3',
}
const USER_ADHERENCE = {
  ASSOCIATED: 1,
  ASSOCIATED_COMPLIANT: 2,
  ALL: 3,
}
const USER_ACCUMULATE = {
  ASSOCIATED: 1,
  ASSOCIATED_COMPLIANT: 2,
  ALL: 3,
}
const USER_REDEMPTION = {
  ASSOCIATED: 1,
  ASSOCIATED_COMPLIANT: 2,
  ALL: 3,
}

const CASHBACK = {
  CAMPAIGN: {
    ADHERENCE,
  },
  PRODUCTS_CAMPINGS: {
    AWARD_TYPE,
    FACTOR_TYPE,
    MODEL_TYPE,
    PAY_WITH_CASHBACK,
  },
  OPERATIONS: {
    TRANSACTION_TYPE,
  },
  TRANSACTION: {
    TRANSACTION_STATUS,
  },
  USER_PERMISSIONS: {
    USER_ADHERENCE,
    USER_ACCUMULATE,
    USER_REDEMPTION,
  },
}

export default CASHBACK
